import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Box,
  SxProps,
  Alert,
  Button,
  Typography,
} from '@mui/material';
//To do
// import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
// import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
// import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
// import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
// import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSignalR } from '../context/signalRContext';
import { getItem, removeItem, setItem } from '../utils/utils';
import { getRoleById } from '../api/requests/roles';
import { colors } from '../utils/constants';

//To do
// const SearchBar = styled('div')(({ theme }) => ({
//   position: 'relative',
//   borderRadius: theme.shape.borderRadius,
//   border: '1px solid rgb(32, 29, 29)',
//   marginRight: theme.spacing(2),
//   width: '100%',
//   [theme.breakpoints.up('sm')]: { width: 'auto' },
// }));

// const SearchIconWrapper = styled('div')(({ theme }) => ({
//   padding: theme.spacing(0, 2),
//   height: '100%',
//   position: 'absolute',
//   pointerEvents: 'none',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
// }));

// const StyledInputBase = styled(InputBase)(({ theme }) => ({
//   color: 'black',
//   '& .MuiInputBase-input': {
//     padding: theme.spacing(1, 1, 1, 0),
//     paddingLeft: `calc(1em + ${theme.spacing(4)})`,
//     transition: theme.transitions.create('width'),
//     width: '100%',
//     [theme.breakpoints.up('md')]: { width: '20ch' },
//   },
// }));

const Navbar: React.FC = () => {
  const connection = useSignalR();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showRoleAlert, setShowRoleAlert] = useState<{
    id?: number;
    value?: string;
  }>({});

  // To do later
  // const [theme, setTheme] = useState('light');

  // const toggleTheme = () => {
  //   setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  // };

  const open = Boolean(anchorEl);

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    navigate('/myprofile');
    handleClose();
  };

  const handleLogoutClick = () => {
    navigate('/signout');
    handleClose();
  };

  const handleRoleUpdated = (data: { userId: number; newRoleId: number }) => {
    const { newRoleId } = data;
    setShowRoleAlert({ id: newRoleId, value: 'userRole' });
    setItem({
      key: 'showRoleAlertInfo',
      value: JSON.stringify({ id: newRoleId, value: 'userRole' }),
    });
  };

  const handleRoleActionsUpdated = () => {
    setShowRoleAlert({ id: user?.roleId, value: 'roleActions' });
    setItem({
      key: 'showRoleAlertInfo',
      value: JSON.stringify({ id: user?.roleId, value: 'roleActions' }),
    });
  };

  const getUserDetails = async () => {
    const userData = await getRoleById(showRoleAlert.id!);
    if (userData?.status === 200 && userData?.data) {
      const oldUserDetails = user;
      const updatedUserDetails = {
        ...oldUserDetails,
        roleId: userData.data.roleId,
        roleName: userData.data.roleName,
        permissions: userData.data.permissions,
      };
      setItem({ key: 'user', value: JSON.stringify(updatedUserDetails) });
    }
  };

  const handleRefresh = async () => {
    if (showRoleAlert) {
      await getUserDetails();
      setShowRoleAlert({});
      removeItem('showRoleAlertInfo');
      window.location.reload();
    }
  };

  useEffect(() => {
    const showRoleAlertInfo = getItem('showRoleAlertInfo');
    if (showRoleAlertInfo) {
      setShowRoleAlert(JSON.parse(showRoleAlertInfo));
    }
  }, []);

  useEffect(() => {
    if (connection) {
      connection.on('RoleChanged', handleRoleUpdated);
      connection.on('RoleUpdated', handleRoleActionsUpdated);

      return () => {
        connection.off('RoleChanged', handleRoleUpdated);
        connection.off('RoleUpdated', handleRoleActionsUpdated);
      };
    }
  }, [connection]);

  return (
    <AppBar position='sticky' sx={appBarStyles}>
      <Toolbar>
        <Typography sx={{ color: colors.white }}>
          Welcome Back {user?.fullName} !
        </Typography>
        {/* Spacer */}
        <Box sx={{ flexGrow: 1 }} />
        {showRoleAlert && showRoleAlert.value && (
          <Box sx={alertCenteredInNavbarStyles}>
            <Alert
              severity='info'
              action={
                <Button
                  size='small'
                  onClick={handleRefresh}
                  sx={reloadButtonStyles}
                >
                  Reload
                </Button>
              }
              sx={alertStyles}
            >
              {showRoleAlert.value === 'userRole'
                ? `Your role has been changed. Please reload to avoid
              unexpected behaviour.`
                : `Your role actions have been updated. Please reload to avoid
              unexpected behaviour.`}
            </Alert>
          </Box>
        )}
        {/* Icons */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {/* <Tooltip
            title={theme === 'light' ? 'Enable Dark Mode' : 'Enable Light Mode'}
          >
            <IconButton color='default' onClick={toggleTheme}>
              {theme === 'light' ? (
                <DarkModeOutlinedIcon />
              ) : (
                <LightModeOutlinedIcon />
              )}
            </IconButton>
          </Tooltip>

          <IconButton color='default'>
            <NotificationsOutlinedIcon />
          </IconButton>
          <IconButton color='default'>
            <MailOutlinedIcon />
          </IconButton> */}
          <IconButton onClick={handleAvatarClick} color='default'>
            <Avatar>{user?.fullName?.charAt(0).toUpperCase()}</Avatar>
          </IconButton>
        </Box>

        {/* Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <MenuItem disabled>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <span>{user?.fullName}</span>
              <span style={{ fontSize: '0.8em', color: 'text.secondary' }}>
                {user?.email}{' '}
              </span>
            </Box>
          </MenuItem>
          <Divider />
          {user?.permissions && (
            <>
              {user.permissions.some(
                (p) => p.module === 'Profile' && p.actions.includes('View')
              ) ? (
                <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
              ) : null}
            </>
          )}{' '}
          <MenuItem onClick={handleClose}>Settings</MenuItem>
          <Divider />
          <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;

const appBarStyles: SxProps = {
  position: 'relative',
  background: `linear-gradient(to right, ${colors.indigoBlueColor}, ${colors.lightSlateBlueColor})`,
  boxShadow: 'none',
  overflow: 'hidden',

  '&::after': {
    content: '""',
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: '8px',
    width: '14%',
    background: `linear-gradient(to right, ${colors.brownYellowColor} 0%, ${colors.brownYellowColor} 50%, ${colors.scarletColor} 50%, ${colors.scarletColor} 100%)`,
    borderTopRightRadius: '12px',
    borderBottomRightRadius: '12px',
  },
};

const alertCenteredInNavbarStyles: SxProps = {
  flexGrow: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  left: 0,
  right: 0,
};

const alertStyles: SxProps = {
  borderRadius: '8px',
  fontSize: '16px',
  padding: '8px 16px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
};

const reloadButtonStyles: SxProps = {
  bgcolor: colors.indigoBlueColor,
  color: colors.white,
  textTransform: 'inherit',
  borderRadius: '8px',
};
